"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserGroupModel = void 0;
var class_validator_1 = require("class-validator");
var UserGroupModel = /** @class */ (function () {
    function UserGroupModel() {
    }
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsInt(),
        class_validator_1.Min(0),
        class_validator_1.Max(2147483647),
        __metadata("design:type", Object)
    ], UserGroupModel.prototype, "sortOrder", void 0);
    __decorate([
        class_validator_1.IsPositive(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Number)
    ], UserGroupModel.prototype, "id", void 0);
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], UserGroupModel.prototype, "title", void 0);
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], UserGroupModel.prototype, "language", void 0);
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], UserGroupModel.prototype, "description", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], UserGroupModel.prototype, "active", void 0);
    __decorate([
        class_validator_1.IsPositive(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Number)
    ], UserGroupModel.prototype, "imageId", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        __metadata("design:type", Object)
    ], UserGroupModel.prototype, "image", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], UserGroupModel.prototype, "help", void 0);
    return UserGroupModel;
}());
exports.UserGroupModel = UserGroupModel;
//# sourceMappingURL=UserGroupModel.js.map